var t=function(t){var a=this.has(t)&&delete this.__data__[t];return this.size-=a?1:0,a};export{t as default};
//# sourceMappingURL=_hashDelete.js.map
